<div class="drop-area w-100 bg-white p-2 {{cssMargin}}" [ngClass]="{'text-success': !!file, 'text-info': !file}">
  <i class="fas fa-file-upload"></i>
  <span class="ms-2">{{file ? file.name : placeholder | translate }}</span>
  <input class="file-input" type="file" accept="">
</div>
<p class="text-danger my-2" *ngIf="file && (file.size / 1024 > 10240)">
  <i class="fas fa-exclamation-triangle text-danger"></i> {{'You exceeded maximum file size. (Max 10MB)' | translate}}
</p>
